module.exports = __webpack_public_path__ + "static/media/newsEvent1.245702a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/images/newsEvent1.jpg
// module id = 104
// module chunks = 0